import React from 'react';

export const DEFAULT_QUICK_CHIPS = [
  'Sin azúcar',
  'Bien frío',
  'Poco dulce',
  'Sin hielo',
  'Para después',
  'Urgente',
  'Para llevar',
  'Bebida primero',
  'Extra servilletas',
  'Poco picante',
];

interface QuickNoteChipsProps {
  value: string;
  onChange: (newValue: string) => void;
  chips?: string[];
  className?: string;
}

export const QuickNoteChips: React.FC<QuickNoteChipsProps> = ({
  value,
  onChange,
  chips = DEFAULT_QUICK_CHIPS,
  className = '',
}) => {
  // Parse current comma-separated tokens
  const currentTokens = React.useMemo(() => {
    return value
      .split(',')
      .map(t => t.trim())
      .filter(Boolean);
  }, [value]);

  const handleToggle = (chip: string) => {
    const chipLower = chip.toLowerCase();
    const existsIndex = currentTokens.findIndex(t => t.toLowerCase() === chipLower);

    let updated: string[];
    if (existsIndex >= 0) {
      // Remove
      updated = currentTokens.filter((_, idx) => idx !== existsIndex);
    } else {
      // Add
      updated = [...currentTokens, chip];
    }

    onChange(updated.join(', '));
  };

  return (
    <div className={`flex flex-wrap gap-1.5 py-1 ${className}`}>
      {chips.map(chip => {
        const isSelected = currentTokens.some(t => t.toLowerCase() === chip.toLowerCase());
        return (
          <button
            key={chip}
            type="button"
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              handleToggle(chip);
            }}
            className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold transition-all duration-150 active:scale-95 ${
              isSelected
                ? 'bg-amber-500 text-white shadow-xs scale-[1.02]'
                : 'bg-slate-100 text-slate-700 hover:bg-slate-200 border border-slate-200 dark:bg-neutral-800 dark:text-neutral-300 dark:border-neutral-700 dark:hover:bg-neutral-700'
            }`}
          >
            {isSelected ? `✓ ${chip}` : chip}
          </button>
        );
      })}
    </div>
  );
};

export default QuickNoteChips;
